/**
 * LocationState — current GPS + compass position, accuracy, speed,
 * heading. Updates fuse the GPS bearing with the compass reading
 * (compass wins if valid because GPS bearing is unreliable below ~5 km/h).
 *
 * Emits `location:changed` on every mutation so StatusPanelView and
 * MapRenderer can react.
 */
export class LocationState {
    constructor(_bus) {
        this._bus = _bus;
        this._lat = null;
        this._lon = null;
        this._accuracy = null;
        this._speed = null;
        this._gpsHeading = null;
        this._compassHeading = null;
        this._street = null;
        this._suburb = null;
        this._city = null;
        this._region = null;
        this._country = null;
        this._countryCode = null;
        this._timestamp = 0;
    }
    /** Apply a position update from GpsTracker */
    updatePosition(pos) {
        this._lat = pos.lat;
        this._lon = pos.lon;
        this._accuracy = pos.accuracy;
        this._speed = pos.speed;
        this._gpsHeading = pos.heading;
        this._timestamp = pos.timestamp;
        this._bus.emit('location:changed', this.snapshot());
    }
    /** Apply a compass update from CompassTracker */
    updateCompass(heading) {
        this._compassHeading = heading;
        this._bus.emit('location:changed', this.snapshot());
    }
    /** Apply reverse-geocoded address (street + city + suburb + region + country) */
    updateAddress(street, city, suburb, region, country, countryCode) {
        this._street = street;
        if (city !== undefined)
            this._city = city;
        if (suburb !== undefined)
            this._suburb = suburb;
        if (region !== undefined)
            this._region = region;
        if (country !== undefined)
            this._country = country;
        if (countryCode !== undefined)
            this._countryCode = countryCode;
        this._bus.emit('location:changed', this.snapshot());
    }
    /** @deprecated Use updateAddress instead */
    updateStreet(street) {
        this._street = street;
        this._bus.emit('location:changed', this.snapshot());
    }
    get hasPosition() {
        return this._lat !== null && this._lon !== null;
    }
    get lat() {
        return this._lat;
    }
    get lon() {
        return this._lon;
    }
    get speed() {
        return this._speed;
    }
    get effectiveHeading() {
        // Prefer compass if available (works when stationary), fall back to GPS bearing
        return this._compassHeading !== null ? this._compassHeading : this._gpsHeading;
    }
    /** Immutable snapshot for view subscribers */
    snapshot() {
        return {
            lat: this._lat,
            lon: this._lon,
            accuracy: this._accuracy,
            speed: this._speed,
            gpsHeading: this._gpsHeading,
            compassHeading: this._compassHeading,
            effectiveHeading: this.effectiveHeading,
            street: this._street,
            suburb: this._suburb,
            city: this._city,
            region: this._region,
            country: this._country,
            countryCode: this._countryCode,
            timestamp: this._timestamp,
        };
    }
}
//# sourceMappingURL=LocationState.js.map